import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import { CURRENT_DATE } from '../../constants';

const ElectionPage = () => {
  const [candidates, setCandidates] = useState([]);

  const [votes, setVotes] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);

  const token = getToken();
  const voterId = decodeToken(token, 'id');
  const branchId = decodeToken(token, 'branch_id');

  useEffect(() => {
    // Fetch candidates from API
    const fetchCandidates = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink/candidates-to-vote`,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );
        console.log('res.data:', res.data);
        setCandidates(res.data.report);
        setLoading(false);
      } catch (err) {
        setError('Failed to load candidates.');
        setLoading(false);
      }
    };

    fetchCandidates();
  }, []);

  const groupedCandidates = candidates.reduce((acc, candidate) => {
    acc[candidate.title] = acc[candidate.title] || [];
    acc[candidate.title].push(candidate);
    return acc;
  }, {});

  const handleVote = (title, candidate) => {
    setVotes((prev) => ({
      ...prev,
      [title]: {
        election_id: candidate.election_id,
        candidate_id: candidate.id,
        election_title_id: candidate.election_title_id,
      },
    }));
  };

  console.log('votes:', votes);
  const handleSubmit = async () => {
    const submissions = Object.entries(votes).map(([title, voteData]) => ({
      branch_id: branchId,
      election_id: voteData.election_id,

      voter_id: voterId,

      election_title_id: voteData.election_title_id,
      candidate_id: voteData.candidate_id,
      date: CURRENT_DATE,
    }));

    try {
      setSubmitting(true);
      setError(null);
      setSuccessMsg(null);

      await Promise.all(
        submissions.map((vote) =>
          axios.post(
            `${API_URL}/${ENDPOINTS.SYS}/create/register-ele_vote`,
            vote,
            {
              headers: {
                Authorization: token ? `Bearer ${token}` : '',
              },
            }
          )
        )
      );

      setSuccessMsg('Votes submitted successfully!');
    } catch (err) {
      setError('Failed to submit all votes.');
    } finally {
      setSubmitting(false);
    }
  };

  const isSubmitDisabled =
    Object.keys(groupedCandidates).length !== Object.keys(votes).length ||
    submitting;

  if (loading)
    return <div className="text-center mt-5">Loading candidates...</div>;
  if (error) return <div className="text-danger text-center mt-5">{error}</div>;

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Election Voting</h2>

      {Object.entries(groupedCandidates).map(([title, titleCandidates]) => (
        <div key={title} className="mb-5">
          <h4 className="mb-3">{title}</h4>
          <div className="row">
            {titleCandidates.map((candidate) => {
              const columnClass =
                titleCandidates.length === 3 ? 'col-md-4' : 'col-md-3';

              return (
                <div className={`${columnClass} mb-4`} key={candidate.id}>
                  <div className="card h-100 shadow-sm">
                    <img
                      src={`https://votingapi.kaafi.net/${candidate.image}`}
                      className="card-img-top"
                      alt={candidate.name}
                      style={{
                        width: '100%',
                        height: '350px',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                    <div className="card-body text-center">
                      <h5 className="card-title">{candidate.name}</h5>
                    </div>
                    <div className="card-footer text-center">
                      <div className="form-check d-flex justify-content-center align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name={title}
                          id={`vote-${candidate.id}`}
                          checked={votes[title]?.candidate_id === candidate.id}
                          onChange={() => handleVote(title, candidate)}
                          style={{
                            transform: 'scale(1.5)',
                            cursor: 'pointer',
                          }}
                        />
                        <label
                          className="form-check-label fw-bold fs-5"
                          htmlFor={`vote-${candidate.id}`}
                        >
                          Vote
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {successMsg && (
        <div className="alert alert-success text-center">{successMsg}</div>
      )}
      {error && <div className="alert alert-danger text-center">{error}</div>}

      <div className="text-center">
        <button
          className="btn btn-primary btn-lg fw-bold w-100 mt-4"
          disabled={isSubmitDisabled}
          onClick={handleSubmit}
        >
          {submitting ? 'Submitting...' : 'Submit Votes'}
        </button>
      </div>
    </div>
  );
};

export default ElectionPage;
